import * as React from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import TransferIcon from '../../Svg/TransferIcon';
import RecieveArrowIcon from '../../Svg/RecieveArrowIcon';
import ArrowDownIcon from '../../Svg/ArrowDownIcon';
import RequestIcon from '../../Svg/RequestIcon';
import { Icon } from '@mui/material';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function CustomStack() {
  return (
    <div style={{display:"flex", justifyContent:"flex-start"}}>
      <Paper sx={{width:"100%"}}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        sx={{display:"flex" , justifyContent:"center"}}
        
      >
        <Item  sx={{width:"auto", height:"auto", boxShadow:"0",display:"flex"}} onClick={()=>alert("Transfer")}>
           <Icon sx={{display:"flex",boxShadow:0}}>
           <TransferIcon />
           </Icon>
            Transfer</Item>
          
        <Item sx={{width:"auto", height:"auto", boxShadow:"0",display:"flex"}}>
        <Icon sx={{display:"flex",boxShadow:0}}><RecieveArrowIcon/></Icon>
            Recieve</Item>

        <Item sx={{width:"auto", height:"auto", boxShadow:"0",display:"flex"}}>
            <Icon sx={{display:"flex",boxShadow:0}}><ArrowDownIcon/></Icon>
            Withdraw</Item>
        <Item sx={{width:"auto", height:"auto", boxShadow:"0",display:"flex"}}>
            <Icon sx={{display:"flex",boxShadow:0}}><RequestIcon/></Icon> 
            Request</Item>
      </Stack>
      </Paper>
    </div>
    
  );
}